let start = () => {};
let stop = () => {};

export const register = (startFn, stopFn) => {
  start = startFn;
  stop = stopFn;
};

export const startLoading = () => start();
export const stopLoading = () => stop();
